var $ = require('jquery');
var AOS = require('aos');

module.exports = {
	init: function () {
		// Find filter tabs anywhere and attach handlers, but scope actions to the closest listing
		const $filterButtons = $('.resource-filter-btn');

		if ($filterButtons.length === 0) {
			return;
		}

		// Handle filter tab clicks
		$filterButtons.on('click', function (e) {
			e.preventDefault();
			const $button = $(this);
			const categoryId = $button.data('category');
			// Scope cards to the closest listing container
			const $listing = $button.closest('.layout.listing');
			const $cards = $listing.find('.card');

			// Toggle active state
			const isActive = $button.attr('aria-selected') === 'true';

			// Deactivate all tabs within this listing
			$listing
				.find('.resource-filter-btn')
				.removeClass('active')
				.attr('aria-selected', 'false')
				.attr('aria-pressed', 'false');

			if (!isActive) {
				// Activate clicked tab
				$button.addClass('active').attr('aria-selected', 'true');

				// Filter cards
				filterCards($cards, categoryId, $button.text());
			} else {
				// Show all cards when deactivating
				$cards.show();
				announceResults($cards.length, 'all categories');
			}

			AOS.refresh(); // Refresh AOS animations after filtering
		});

		// Filter cards function
		function filterCards($cards, categoryId, categoryName) {
			let visibleCount = 0;
			$cards.each(function () {
				const $card = $(this);
				const cardCategories = $card.data('categories');

				if (cardCategories) {
					const categoriesArray = cardCategories
						.toString()
						.split(',')
						.map((id) => parseInt(id));

					if (categoriesArray.includes(parseInt(categoryId))) {
						$card.show();
						visibleCount++;
					} else {
						$card.hide();
					}
				} else {
					$card.hide();
				}
			});

			// Announce results to screen readers
			announceResults(visibleCount, categoryName);
		}

		// Function to announce filter results to screen readers
		function announceResults(count, category) {
			const message =
				count === 1
					? `Showing ${count} resource in ${category}`
					: `Showing ${count} resources in ${category}`;

			// Create or update live region for announcements
			let $liveRegion = $('#resource-filter-announcement');
			if ($liveRegion.length === 0) {
				$liveRegion = $(
					'<div id="resource-filter-announcement" class="sr-only" aria-live="polite" aria-atomic="true"></div>'
				);
				$('body').append($liveRegion);
			}
			$liveRegion.text(message);
		}

		// Trigger filter for first active tab on page load
		// Handle each listing that contains resource filters separately
		$('.layout.listing').each(function () {
			const $listing = $(this);
			const $activeButton = $listing.find('.resource-filter-btn.active').first();

			if ($activeButton.length > 0) {
				const categoryId = $activeButton.data('category');
				const $cards = $listing.find('.card');
				filterCards($cards, categoryId, $activeButton.text());
			}
		});
	},
};
